import { useTour } from '@/components/TourProvider'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const useOpenTour = () => {
    const { start, exit, setCurrentStep, currentStep } = useTour()
    const location = useLocation()

    useEffect(() => {
        const hasSeenTour = localStorage.getItem(location.pathname)

        if (!hasSeenTour) {
            // Delay để đảm bảo DOM đã render xong
            setTimeout(() => {
                start()
            }, 100)
            localStorage.setItem(location.pathname, 'true')
        }
    }, [location.pathname, start])

    return {
        start,
        exit,
        setCurrentStep,
        currentStep,
    }
}

export default useOpenTour
